import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiHelper } from 'src/cad/common/services/api/api-helper';

@Injectable()
export class CapacityReleaseOfferPreArrangedBidApi {
  private readonly endpoint: string = 'capacity-release/offer/';
  private readonly suffix: string = '/pre-arranged-bid';

  constructor(private apiHelper: ApiHelper) {}

  public getPRSBidderList = (auctionId: number | string): Observable<any> => {
    return this.apiHelper.request(this.endpoint + auctionId + this.suffix);
  }

  public save = (auctionId: number | string, offerData: any): Observable<any> => {
    return this.apiHelper.request(this.endpoint + auctionId + this.suffix + '/save', { body: offerData });
  }
}
